<template>
    <div>
        <v-container fluid class="px-0 search-doctor-banner pb-0 d-flex justify-center align-center" :style="$vuetify.breakpoint.mdAndUp ? 'min-height: 230px' : 'min-height: 175px'">
            <v-container fluid class="d-flex justify-center align-center">
                <v-row class="d-flex justify-center align-center" style="width:100%">
                    <v-col cols="12 text-center">
                        <div class="darkergray--text playfair-display mb-2 weight-semibold text-center" :class="$vuetify.breakpoint.mdAndUp ? 'font-32' : 'font-16'">
                            FAQs
                        </div>
                        <div class="darkergray--text playfair-display mb-2 weight-semibold text-center" :class="$vuetify.breakpoint.mdAndUp ? 'font-32' : 'font-16'">
                            Here is a list of questions that are frequently asked to us
                        </div>
                    </v-col>
                </v-row>
                <br>
                <v-row class="py-4">
                    <v-col cols="12" class="py-4">
                    </v-col>
                </v-row>
                <br>
            </v-container>
        </v-container>
        <v-container>
            <v-row>
                <v-col cols="12" sm="12" md="4">
                    <v-card
                            class="mx-auto"
                            tile
                    >
                        <v-list class="">
                            <v-list-item-group mandatory v-model="selectedFaq1" color="darkergray">
                                <v-list-item
                                        v-for="(item, i) in faqList"
                                        :key="i"
                                        @click="selectedFaq = item"
                                >
                                    <v-list-item-icon>
                                        <v-icon v-text="item.icon" color="darkergray"></v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title v-text="item.title"></v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="7" offset-md="1">
                    <v-row>
                        <v-col cols="12" sm="12" class="">
                            <h2>
                                <v-icon v-text="selectedFaq.icon" color="darkergray" large class="mr-2"></v-icon>  {{ selectedFaq.title }}
                            </h2>
                        </v-col>
                        <v-col cols="12" sm="12" class="">                        
                            <v-expansion-panels flat class="font-weight-medium" v-model="expandedList">
                                <v-expansion-panel  
                                
                                    v-for="(questionAnswer, i) in selectedFaq.faqs"
                                    :key="questionAnswer.id"
                                    class="question-expansions" 
                                    style="border-bottom: 1px solid #ccc; padding-left: 0"
                                >
                                    <v-expansion-panel-header 
                                        class="grey--text text--darken-4"
                                        :class="expandedList == i ? 'weight-semibold' : 'weight-light'"
                                    >
                                        {{ i + 1 }}. {{ questionAnswer.question }}
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                    <span class="grey--text weight-regular font-15 text--darken-1"
                                          v-html="questionAnswer.answer"></span>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    export default {
        name: "FAQ",
        mounted() {
            this.getFaqList();
        },
        data() {
            return {
                faqList: [],
                selectedFaq: {},
                selectedFaq1: {},
                expandedList:null,
            }
        },
        methods: {
            getFaqList() {
                this.axios.get(`${process.env.VUE_APP_API_URL}/api/faq/get-faq-list`)
                    .then((response) => {
                        this.faqList = response.data.data;
                        this.selectedFaq = this.faqList[0];
                    }).catch((error) => {
                    console.log(error);
                    this.isLoading = false;
                });
            },
        },
    }
</script>